import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useTchScaleTemplatesListQueryV1(workspaceId?: number | Ref<number>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const result = {
		workspaceId: _workspaceId,
		...useQuery(() => new q.TchScaleTemplatesListQueryV1(_workspaceId.value))
	}
	return {
		...result,
		runTchScaleTemplatesListQueryV1: result.run,
		modelTchScaleTemplatesListQueryV1: result.model,
	}
}

export function useWorkspaceScalesListQueryV1(workspaceId?: number | Ref<number>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const result = {
		workspaceId: _workspaceId,
		...useQuery(() => new q.WorkspaceScalesListQueryV1(_workspaceId.value))
	}
	return {
		...result,
		runWorkspaceScalesListQueryV1: result.run,
		modelWorkspaceScalesListQueryV1: result.model,
	}
}

